<main id="main-content" class="content-page">
  <nav class="breadcrumbs" aria-label="Breadcrumb">
    <a routerLink="/">Home</a><span aria-hidden="true">/</span>
    @if (!isIndex()) {
      <a [href]="basePath">Legal center</a><span aria-hidden="true">/</span>
      <span aria-current="page">{{ page()?.title }}</span>
    } @else {
      <span aria-current="page">Legal center</span>
    }
  </nav>

  @if (page(); as policy) {
    <article class="article-shell">
      <header class="article-intro">
        <p class="eyebrow">IQLABTEST LEGAL CENTER</p>
        <h1>{{ policy.title }}</h1>
        <p class="lead">{{ policy.summary }}</p>
        <p class="reviewed">Last updated {{ lastUpdated }}</p>
      </header>
      <div class="article-layout">
        <aside class="toc" aria-label="On this page">
          <strong>On this page</strong>
          @for (section of policy.sections; track section.heading; let index = $index) {
            <a [href]="pagePath() + '#section-' + index">{{ section.heading }}</a>
          }
          <a [href]="pagePath() + '#frequently-asked-questions'">Questions</a>
        </aside>
        <div class="article-body">
          @for (section of policy.sections; track section.heading; let index = $index) {
            <section [id]="'section-' + index">
              <h2>{{ section.heading }}</h2>
              @for (paragraph of section.paragraphs; track paragraph) {
                <p>{{ paragraph }}</p>
              }
              @if (section.bullets) {
                <ul>
                  @for (item of section.bullets; track item) {
                    <li>{{ item }}</li>
                  }
                </ul>
              }
            </section>
          }
          <section id="frequently-asked-questions" class="faq">
            <p class="eyebrow">QUESTIONS</p>
            <h2>Frequently asked questions</h2>
            @for (faq of policy.faqs; track faq.question) {
              <details>
                <summary>{{ faq.question }}</summary>
                <p>{{ faq.answer }}</p>
              </details>
            }
          </section>
          @if (policy.sources?.length) {
            <section class="sources" aria-labelledby="legal-sources-heading">
              <h2 id="legal-sources-heading">Official references</h2>
              <ul>
                @for (source of policy.sources; track source.url) {
                  <li>
                    <a [href]="source.url" target="_blank" rel="noopener">{{ source.label }}</a>
                  </li>
                }
              </ul>
            </section>
          }
          <aside class="editorial-note">
            <strong>Legal review</strong>
            <p>
              These English notices document the current product design and general EU requirements.
              They require review by qualified counsel for the operator’s legal entity,
              establishment, markets, and actual production configuration.
            </p>
          </aside>
        </div>
      </div>
    </article>
    <section class="related">
      <p class="eyebrow">RELATED POLICIES</p>
      <h2>Continue reading</h2>
      <div class="card-grid">
        @for (related of relatedPages(policy); track related.slug) {
          <a dsCard class="content-card" [href]="urlFor(related.slug)">
            <h3>{{ related.title }}</h3>
            <p>{{ related.description }}</p>
            <span>Read policy →</span>
          </a>
        }
      </div>
    </section>
  } @else {
    <section class="index-intro">
      <p class="eyebrow">IQLABTEST LEGAL CENTER</p>
      <h1>Policies and consumer information</h1>
      <p>
        Plain-English information about privacy, cookies, digital purchases, certificates, refunds,
        and data retention.
      </p>
    </section>
    <section class="index-grid" aria-label="Legal documents">
      @for (policy of pages; track policy.slug) {
        <a dsCard class="content-card" [href]="urlFor(policy.slug)">
          <h2>{{ policy.title }}</h2>
          <p>{{ policy.description }}</p>
          <span>Read policy →</span>
        </a>
      }
    </section>
  }
</main>
